import { Component } from "react";
import { toast } from "react-toastify";
import fileIcon from "../assets/fileIcon.png";
import "../module.scss";
import { LayoutWrapper } from "../../../LayoutWrapper";

export class AppPage extends Component {
  constructor(props) {
    super(props);
    props.initialconstruct.bind(this)("AppPage");
    this.state = {
      data: [],
      selectedFile: {},
      sessionDetails: {},
      breadcrum: "",
      current_id: "",
      htmls: [],
      isFullScreen: false,
    };
  }

  componentDidMount() {
    document.addEventListener("contextmenu", (e) => {
      e.preventDefault();
    });
    this.fetchData();
    document.addEventListener("fullscreenchange", this.handleFullScreenChange);
  }

  componentWillUnmount() {
    document.removeEventListener(
      "fullscreenchange",
      this.handleFullScreenChange
    );
  }

  handleFullScreenChange = () => {
    this.setState({
      isFullScreen: !!document.fullscreenElement,
    });
  };

  toggleFullScreen = () => {
    const element = document.getElementById("zippage-iframe-container");
    if (!element) return;

    if (!document.fullscreenElement) {
      element.requestFullscreen().catch((err) => {
        console.error(`Error attempting to enable fullscreen: ${err.message}`);
      });
    } else {
      document.exitFullscreen();
    }
  };

  async fetchData() {
    try {
      const sessionId =
        this.props.urlparams.sessionId || this.props.urlparams.session_id;
      if (sessionId) {
        localStorage.setItem("session_id", sessionId);
      }

      let payload = {
        session_id: sessionId,
        content_type: "AI",
      };

      let res;
      try {
        res = await this.props.api.apiGetContentBySession(payload);
      } catch (err) {
        console.error("Error fetching AI content:", err);
      }
      let data = res?.data || [];

      if (!data.length) {
        try {
          const appRes = await this.props.api.apiGetContentBySession({
            session_id: sessionId,
            content_type: "APP",
          });
          data = appRes?.data || [];
        } catch (err) {
          console.error("Error fetching APP content:", err);
        }
      }

      // Deduplicate data by content_id or attach_file
      const uniqueData = Array.from(
        new Map(
          (data || []).map((item) => [
            item.content_id || item.attach_file || item.id,
            item,
          ])
        ).values()
      );

      const htmls = await Promise.all(
        uniqueData.map(async (obj) => {
          const metadataPayload = {
            attachment_id: obj.attach_file,
          };

          let metaRes = null;
          try {
            metaRes = await this.props.api.apiGetFileMetaData(metadataPayload);
            console.log("Meta data: ", metaRes?.url);
          } catch (e) {
            console.error("Meta data error: ", e);
          }

          const url = `${this.linkGeneration(obj.attach_file)}`;
          return {
            ...obj,
            url,
            fileName: obj?.content_title || metaRes?.file_name || "App Activity",
          };
        })
      );

      this.setState({
        data: uniqueData,
        current_id: uniqueData[0]?.attach_file || "",
        selectedFile: htmls[0] || {},
        htmls: htmls,
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  getSelectedFile(item) {
    this.setState({
      selectedFile: item,
    });
  }

  completed(event, box) {
    const sessionId =
      this.props.urlparams.sessionId || this.props.urlparams.session_id;
    if (sessionId) {
      let payload = {
        class_id: localStorage.getItem("class_id"),
        module_id: localStorage.getItem("module_id"),
        session_id: sessionId,
        content_id: box?.content_id,
        progress: event.target.checked ? 100 : 0,
      };
      this.props.api
        .apiRecordConentProgress(
          { school_id: localStorage.getItem("school_id") },
          payload
        )
        .then(() => {
          this.fetchData();
          toast.success("Activity Completion Status Updated", {
            autoClose: 3000,
            closeButton: false,
            hideProgressBar: true,
          });
        });
    }
  }

  routeToSession(e) {
    e.preventDefault();
    e.stopPropagation();
    this.props.navigate(
      `/mycontent/sessions?packageId=${this.props.urlparams?.packageId}&packageName=${this.props.urlparams?.packageName}`
    );
  }

  getBreadCums() {
    let packageName = this.props.urlparams?.packageName || "";
    let sessionName = this.props.urlparams?.sessionName || "";
    if (packageName && sessionName) {
      return `My Content / ${packageName} / ${sessionName} : App`;
    }
    return "My Content / App";
  }

  getBackLink() {
    if (this.props.urlparams?.packageId) {
      return `/mycontent/sessions?packageId=${this.props.urlparams.packageId}&packageName=${this.props.urlparams.packageName}`;
    }
    return "/mycontent/sessions";
  }

  getTitle() {
    return "My Content";
  }

  linkGeneration(attach_file) {
    let authToken = window.store.getState()?.root?.auth || "";
    let fileId = attach_file;
    if (fileId && (fileId.startsWith("http://") || fileId.startsWith("https://"))) {
      const parts = fileId.split("?")[0].split("/");
      fileId = parts[parts.length - 1];
    }
    return (
      app.api
        .request(app.apis().fileDownloader)
        .urltransform({ attachmentId: fileId }).url +
      "?auth=" +
      authToken
    );
  }

  render() {
    let {
      data = [],
      selectedFile,
      sessionDetails,
      breadcrum,
      htmls,
    } = this.state;

    return (
      <LayoutWrapper
        title={this.getTitle()}
        back={this.getBreadCums()}
        backlink={this.getBackLink()}
      >
        <div className="card bg-white media_box">
          <div className="card-header">
            <h3 className="title">
              {this.props.urlparams?.sessionName ||
                data[0]?.content_title ||
                "App Activity"}
            </h3>
          </div>
          <div className="card-body px-0">
            <div className="row g-4 mx-auto px-0">
              {selectedFile && selectedFile.url && (
                <div className="col-md-7">
                  <div
                    id="zippage-iframe-container"
                    className="iframe_container"
                    style={{ minHeight: "600px", position: "relative" }}
                  >
                    <iframe
                      src={selectedFile.url}
                      frameBorder="0"
                      allow="autoplay; fullscreen; picture-in-picture"
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        border: "none",
                        borderRadius: "8px",
                      }}
                      title={
                        selectedFile.fileName ||
                        this.props.urlparams?.sessionName ||
                        "App Activity"
                      }
                    />
                    <button
                      onClick={this.toggleFullScreen}
                      className={`btn btn-sm position-absolute ${this.state.isFullScreen ? "btn-danger" : "btn-primary"
                        }`}
                      style={{
                        top: "12px",
                        right: "12px",
                        zIndex: 1000,
                        borderRadius: "4px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                        ...(this.state.isFullScreen
                          ? {}
                          : {
                            backgroundColor: "#fba106",
                            borderColor: "#fba106",
                            color: "#fff",
                          }),
                      }}
                    >
                      {this.state.isFullScreen ? (
                        <>
                          <i
                            className="fa fa-compress"
                            style={{ marginRight: "6px" }}
                          />
                        </>
                      ) : (
                        <>
                          <i
                            className="fa fa-expand"
                            style={{ marginRight: "6px" }}
                          />
                        </>
                      )}
                    </button>
                  </div>
                </div>
              )}
              <div className="col-12 col-md-5">
                <p className="content_description">
                  {selectedFile?.content_description ||
                    data[0]?.content_description ||
                    ""}
                </p>
                <div className="mini_box_container">
                  {htmls?.length ? (
                    htmls?.map((box, j) => {
                      const isSelected =
                        selectedFile &&
                        (selectedFile === box ||
                          (selectedFile.url && selectedFile.url === box.url));

                      return (
                        <div
                          className={`mini_box ${isSelected ? "active" : ""}`}
                          key={j}
                          onClick={() => this.getSelectedFile(box)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                              e.preventDefault();
                              this.getSelectedFile(box);
                            }
                          }}
                          tabIndex={0}
                          role="button"
                          aria-selected={isSelected}
                        >
                          <div className="d-flex align-items-center justify-content-between w-100 gap-3">
                            <div className="d-flex align-items-center gap-3 w-100">
                              <div className="thumbnail_box">
                                <img src={fileIcon} alt="Activity Icon" />
                              </div>
                              <div>
                                <p className="title mb-0">
                                  {box.fileName || box.content_title}
                                </p>
                              </div>
                            </div>
                            <div className="flex-shrink-0 ms-2">
                              {isSelected && (
                                <i
                                  className="fa fa-check-circle text-warning fs-5"
                                  title="Selected"
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <p>Not found</p>
                  )}
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div
            className="card-footer social_box"
            style={{
              position: "static",
            }}
          >
            <button
              type="button"
              onClick={(...args) => this.routeToSession(...args)}
              className="btn add-btn min-wd-100 mr-2"
            >
              Back To Sessions
            </button>
          </div>
        </div>
      </LayoutWrapper>
    );
  }
}

export default connect(AppPage);
